<template>
  <div>
    <table class="table week is-fullwidth">
        <thead>
            <tr>
                <th v-for="n in 10" v-if="n==1" v-bind:key="n" class="project-column">
                    {{$t("settings.project")}} 
                    <a class="button is-info is-small" @click="useTimeTemplate()" v-if="isThereATimeTemplate" style="margin-left: 0.8em;">
                        <span class="icon">
                          <font-awesome-icon :icon="['fas', 'paste']"></font-awesome-icon>
                        </span>
                        {{$t("settings.useTimeTemplate")}}
                    </a>
                </th>
                <th v-else-if="n==2" style="text-align:right">
                    <router-link v-if="Number($route.params.time) > 0" class="button is-primary" :to="{ params: { time: Number($route.params.time) - 1 }}"> &lt; </router-link>
                </th>
                <th v-else-if="n>2 && n<10" v-bind:class="{ weekendStyle: n==8 || n==9 || calendar.methods.isDateAholiday(momentWeek(n-3, true),dkHolidays)}" style="width:80px">
                    <small>
                        {{momentWeek(n-3)}}
                    </small>
                </th>
                <th v-else>
                    <router-link v-if="Number($route.params.time) < numberOfWeeksInYear" class="button is-primary" :to="{ params: { time: Number($route.params.time) + 1 }}"> &gt; </router-link>
                </th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td>
                    <a @click="sendWeekRegForApproval()" class="button is-small is-primary">
                        {{$t("input.sendForApp")}}
                    </a>
                    <p class="help">{{$t("settings.allRegsText")}} </p>
                </td>
                <th>
                    <small>
                        <weekTimeSum :all-registrations="allRegistrations" :personal-settings="personalSettings.settings" :week-no="Number($route.params.time)"/>
                    </small>
                </th>
                <th v-for="n in 10" v-if="n>2 && n<10" v-bind:key="n" style="width:80px">
                        <small>
                            <span class="tag is-light" v-if="dateSum(momentDate(n-3)) < workWeekTime(momentDate(n-3)) || !dateSum(momentDate(n-3))">
                                {{ dateSum(momentDate(n-3)) }}
                                <span v-if="workWeekTime(momentDate(n-3)) > 0">
                                    &nbsp;/ {{ workWeekTime(momentDate(n-3)) }}
                                </span>
                            </span>
                            <span class="tag is-success" v-if="(dateSum(momentDate(n-3)) >= workWeekTime(momentDate(n-3))) && dateSum(momentDate(n-3)) > 0">
                                {{ dateSum(momentDate(n-3)) }}
                                <span v-if="workWeekTime(momentDate(n-3)) > 0">
                                    &nbsp;/ {{ workWeekTime(momentDate(n-3) )}}
                                </span>
                            </span>
                        </small>
                </th>
                <th></th>
            </tr>
        </tfoot>
        <tbody>
            <tr v-for="regs in returnWithStandardOrNot" v-bind:key="regs['.key']">
                <td v-for="n in 10" v-if="n==1" v-bind:key="n">
                    <span v-for="reg in unique(regs, 'projectCombined')" v-bind:key="reg['.key']">
                        <strong>
                            {{returnProjectDescription(reg.project, reg.isCustomProject)}}
                        </strong>
                        <span v-if="reg.project && !reg.isCustomProject" class="tag is-small is-info tag-margin">
                            {{ reg.project }}
                        </span>
                        <br>
                        <small>{{returnProjectLineDescription(reg.project, reg.projectLine, reg.isCustomProject)}}</small>
                    </span>
                </td>
                <td v-else-if="n==2"></td>
                <td v-else-if="n>2 && n<10" v-bind:class="{ weekendStyle: n==8 || n==9 || calendar.methods.isDateAholiday(momentWeek(n-3, true),dkHolidays) }">
                    <span v-for="(reg, index) in unique(regs, 'date')" v-bind:key="reg['.key']">
                        <TimeWeekInput v-if="momentDate(n-3) == reg.date" :week-date="momentDate(n-3)" :week-project-key="reg['.key']" :week-project-no="reg.project" :week-project="reg.projectCombined" :week-project-line="reg.projectLine" :week-is-approved="reg.isApproved"></TimeWeekInput>
                        <TimeWeekInputEmpty v-else-if="index == 0" :week-date="momentDate(n-3)" :week-project-no="reg.project" :week-project-line="reg.projectLine" :week-project="reg.projectCombined"></TimeWeekInputEmpty>
                    </span>
                </td>
                <td v-else-if="n==10"><span class="tag is-light">{{timeSum(regs)}}</span></td>
            </tr>
        </tbody>
    </table>
  </div>
</template>

<script>
import firebase from '@/firebase'
import moment,{ calendarFormat } from 'moment'
import _ from 'lodash'
import TimeWeekInput from '@/components/week/TimeWeekInput.vue'
import TimeWeekInputEmpty from '@/components/week/TimeWeekInputEmpty.vue'

import calendar from '../../utils/calendar'
import templates from '../../utils/templates.vue'
import weekTimeSum from '../../utils/weekTimeSum.vue'

export default {
  name: 'TimeWeekTable',
  components: {
    TimeWeekInput,
    TimeWeekInputEmpty,
    weekTimeSum
  },
   data: function() {
       return {
        weekTime: '',
        currentWeek: moment().isoWeek(),
        selectedProject: false,
        endOfWeek: false,
        error: false,
        timeTemplate: [],
       }
   },
    firebase: function() { 
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        const userid = JSON.parse(localStorage.getItem('profile')).user_id;
        return {
            allRegistrations: {
                source: firebase.database().ref('/organisations/' + tenantid + '/registrations/' + userid).orderByChild('projectCombined'),
            },
            allProjects: {
                source: firebase.database().ref('/organisations/' + tenantid + '/JobList'),
            },
            allProjectLines: {
                source: firebase.database().ref('/organisations/' + tenantid + '/JobTaskLines'),
            },
            dkHolidays: {
                source: firebase.database().ref('/holidays/dk/' + moment().year()),
            },
            orgSettings: {
                source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
                asObject: true,
            },
            personalSettings: {
                source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid),
                asObject: true,
            }
        }
    },
    beforeCreate: function() {
        this.calendar = calendar
        this.templates = templates
    },
  computed: {
    isThereATimeTemplate() {
        if(this.personalSettings.timeTemplate) { return true } else { return false }
    },
    weekSum() {
      const self = this;
      const sum = _.sumBy(_.filter(this.allRegistrations, function(o) {
          if(moment(o.date).isoWeek() ===  Number(self.$route.params.time)) {return o}
      }), 'time');
      if (sum > 0) {
        return sum;
      } else {
        return 0;
      }
    },
    numberOfWeeksInYear: function() {
      moment.locale(this.$i18n.locale)
      return moment().isoWeeksInYear();
    },
    returnWithStandardOrNot() {
        if(this.orgSettings && this.orgSettings.standardProject) {
            const hasProjectBeenRegisteredOn = _.find(this.allRegistrations, {'project': this.orgSettings.standardProject.no, 'projectLine': this.orgSettings.standardProject.task_no})
        if(!hasProjectBeenRegisteredOn && this.orgSettings.useStandardProject && this.orgSettings.standardProject) {
            return this.allRegistrationsStandardProject
        } else {
            return this.allRegistrationsUnique;
        }
        } else {
            return this.allRegistrationsUnique;
        }
    },
    allRegistrationsStandardProject() {
        let projectCombined = {}
        const projectString = this.orgSettings.standardProject.no + '-' + this.orgSettings.standardProject.task_no
        projectCombined[projectString] = [{
            isCustomProject:true,
            project:this.orgSettings.standardProject.no,
            projectCombined: projectString,
            projectLine:this.orgSettings.standardProject.task_no,
        }]
        return projectCombined
    },
    allRegistrationsUnique: function () {
        return _.groupBy(this.allRegistrations, 'projectCombined')
    },
    isThereAnythingToApprove() {

    }
  },
  methods: {
    useTimeTemplate() {
        const self = this;
        const regs = this.templates.methods.useTimeTemplate(this.$route.params.time, this.orgSettings, this.personalSettings)
        _.forEach(regs, function(registration) {
            self.$firebaseRefs.allRegistrations.push(registration)
        })
    },
    workWeekTime: function(date) {
        if(this.personalSettings.settings) {
            const settings = this.personalSettings.settings;
            switch (moment(date).isoWeekday()) {
            case 1:
                return settings.monday;
                break;
            case 2:
                return settings.tuesday;
                break;
            case 3:
                return settings.wednesday;
                break;
            case 4:
                return settings.thursday;
                break;
            case 5:
                return settings.friday;
                break;
            case 6:
                return settings.saturday;
                break;
            case 7:
                return settings.sunday;
                break;
            }
        }
    },
    dateSum: function(date) {
      // sum time per date from week table
      const sum = _.sumBy(_.filter(this.allRegistrations, {'date': date}), 'time');
      if (sum > 0) {
        return sum;
      } else {
        return 0;
      }
    },
    returnProjectDescription: function(projectNo, isCustom) {
      if(!isCustom) {
        const project = _.find(this.allProjects, { 'no': projectNo });
        if (project) {
          return project.description;
        } else {
          return;
        }
      } else {
        const project = _.get(this.orgSettings.customProjects, projectNo);
        if (project) {
          return project.name;
        } else {
          return;
        }
      }
    },
    returnProjectLineDescription: function(projectNo, lineNo, isCustom) {
      if(!isCustom) {
        const projectLine = _.find(this.allProjectLines, { 'no': projectNo , 'task_no': lineNo});
        if (projectLine) {
          return projectLine.description;
        } else {
          return;
        }
      } else {
        const projectLine = _.get(this.orgSettings.customProjectLines, lineNo);
        if (projectLine) {
          return projectLine.name;
        } else {
          return;
        }
      }
    },
    timeSum: function(regs) {
      return _.sumBy(regs, 'time');
    },
    setProject: function(projectNo) {
      this.selectedProject = projectNo;
    },
    unique: function (value, key) {
      return _.uniqBy(value, key)
    },
    moment: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    momentWeek: function(addDays, dateFormat) {
      // return moment().startOf('isoWeek').add(addDays, 'days').format('DD/MM');
      // set locale to dk
      moment.locale(this.$i18n.locale)
      if(this.$route.params.time) {
        if(dateFormat) {
            return moment().isoWeek(this.$route.params.time).startOf('isoWeek').add(addDays, 'days');
        } else {
            return moment().isoWeek(this.$route.params.time).startOf('isoWeek').add(addDays, 'days').format('ddd DD/MM');
        }
      } else {
           if(dateFormat) {
                return moment().isoWeek(this.currentWeek).startOf('isoWeek').add(addDays, 'days').format('ddd DD/MM');
           } else {
                return moment().isoWeek(this.currentWeek).startOf('isoWeek').add(addDays, 'days').format('ddd DD/MM');
           }
      }
    },
    momentDate: function(addDays) {
      if(this.$route.params.time) {
        return moment().isoWeek(this.$route.params.time).startOf('isoWeek').add(addDays, 'days').format('YYYY-MM-DD');
      } else {
        return moment().isoWeek(this.currentWeek).startOf('isoWeek').add(addDays, 'days').format('YYYY-MM-DD');
      }
    },
    sendWeekRegForApproval: function() {
      let endOfWeek;
      if(this.$route.params.time) {
        endOfWeek = moment().isoWeek(this.$route.params.time).endOf('isoWeek').format('YYYY-MM-DD');
      } else {
        endOfWeek = moment().isoWeek(this.currentWeek).endtOf('isoWeek').format('YYYY-MM-DD');
      }
      const registrations = _.filter(this.allRegistrations, function(o) {
          if((o.isApproved === false || !o.isApproved ) && o.date < endOfWeek) {
              return o;
          } 
      });

      //   for each registration push an approval in firebase
      let updates = {};
      for (var i = 0, len = registrations.length; i < len; ++i) {
          // add update information to array
          updates[registrations[i]['.key'] + '/sentForApproval'] = true;
      }
      try {
        this.$firebaseRefs.allRegistrations.update(updates)
      } catch(error) {
          this.error = error
      } finally {
          if(!this.error) {
              if(_.find(registrations, {'sentForApproval': false})) {
                  this.$snotify.success('Sendt til godkendelse', {
                    showProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true
                    });
                } else {
                  this.$snotify.warning('Ingen registreringer der kan sendes til godkendelse', {
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true
                    });                    
                }
          }
      }

    //   const self = this;
    //   const yesAction = function (toast) {
    //       if (!toast.value.match('snotify')) {
    //           toast.valid = false;
    //           return false;
    //       }
    //       else {
    //           toast.valid = true; // default value
    //           self.$snotify.remove(toast.id);
    //       }
    //   };
    //   const noAction = function (toast) {
    //       self.$snotify.remove(toast.id); // default
    //   };
    //   this.$snotify.prompt(null, 'Godkendelse', {
    //       buttons: [
    //           { text: 'Send', action: yesAction, bold: true },
    //           { text: 'Annuller', action: noAction },
    //       ],
    //       placeholder: 'Tilføj evt. en kommentar'
    //   });
    }
  }
}
</script>
<style>

.weekendStyle {
  background-color: #fafafa;
}
.project-column {
    min-width: 25%;
}
.snotify-prompt {
    border-left: 4px solid #00d1b2;
}
.snotify-success {
     border-left: 4px solid #23d160!important;
}
.snotify-warning {
     border-left: 4px solid #ffdd57!important;
}
.snotify-icon--warning {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns=%22http://www.w3.org/2000/svg%22%20version=%221.1%22%20x=%220px%22%20y=%220px%22%20viewBox=%220%200%20512%20512%22%20fill=%22%23ffdd57%22%3E%3Cg%3E%3Cpath%20d=%22M256,512c141.15,0,256-114.84,256-256S397.15,0,256,0,0,114.84,0,256,114.85,512,256,512Zm0-480.49c123.79,0,224.49,100.71,224.49,224.49S379.79,480.49,256,480.49,31.51,379.79,31.51,256,132.21,31.51,256,31.51Z%22/%3E%3Ccircle%20cx=%22260.08%22%20cy=%22343.87%22%20r=%2226.35%22/%3E%3Cpath%20d=%22M254.68,278.39a15.76,15.76,0,0,0,15.75-15.75V128.72a15.75,15.75,0,1,0-31.51,0V262.63A15.76,15.76,0,0,0,254.68,278.39Z%22/%3E%3C/g%3E%3C/svg%3E")!important;
}
.tag-margin {
    margin-left: 0.5em;
}
</style>

